module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"yearsOld":"0 years | {n} year | {n} years | {n} years"}}')
  delete Component.options._Ctor
}
